import React, { useState } from "react";
import Attachment from "./Attachment";
import Modal from "../Modal/Modal";
function AttachmentWidget(props) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const sendUpload = function (file, fileName, preview) {
        setIsModalOpen(false);
        props.selectFileCb(file, fileName, preview);
    };
    return (
        <div className="opt-map-widget">
            <Modal
                small
                show={isModalOpen}
                language={props.language}
                closeCb={() => setIsModalOpen(false)}
            >
                <Attachment
                    language={props.language}
                    uploadImageCb={sendUpload}
                    closeCb={() => setIsModalOpen(false)}
                />
            </Modal>
            <span className="opt-map-widget__text" onClick={() => setIsModalOpen(!isModalOpen)}>
                {props.text}
            </span>
        </div>
    );
}
export default AttachmentWidget;
